var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.51825 0 0.5 2.01825 0.5 4.5C0.5 7.61925 4.562 11.7172 4.7345 11.8905C4.808 11.9633 4.904 12 5 12C5.096 12 5.192 11.9633 5.2655 11.8905C5.438 11.7172 9.5 7.61925 9.5 4.5C9.5 2.01825 7.48175 0 5 0ZM5 11.0828C4.1045 10.1243 1.25 6.88275 1.25 4.5C1.25 2.43225 2.93225 0.75 5 0.75C7.06775 0.75 8.75 2.43225 8.75 4.5C8.75 6.8805 5.8955 10.1243 5 11.0828Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.25C3.7595 2.25 2.75 3.2595 2.75 4.5C2.75 5.7405 3.7595 6.75 5 6.75C6.2405 6.75 7.25 5.7405 7.25 4.5C7.25 3.2595 6.2405 2.25 5 2.25ZM5 6C4.17275 6 3.5 5.32725 3.5 4.5C3.5 3.67275 4.17275 3 5 3C5.82725 3 6.5 3.67275 6.5 4.5C6.5 5.32725 5.82725 6 5 6Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.d6bf8f06c98626319d88063f0d8c1176.svg";
export { ForwardRef as ReactComponent };